<template>
    <v-row no-gutters>
        <v-col cols="12" sm="10" offset-sm="1">
            <span class="headline">Vijesti</span>
            <bit-page :breadcrumbs="breadcrumbs"></bit-page>
            <v-row align="center" class="white mt-3 pa-3" no-gutters>
                <span class="title green--text text--darken-3">Vijesti</span>
                <v-col class="d-flex mb-3" cols="12">
                    <v-divider></v-divider>
                </v-col>
                <v-col class="d-flex" cols="12">
                    <v-data-table
                            class="mt-4"
                            style="width: 100%;border: 1px solid #ddd;border-radius: 0"
                            :search="search"
                            :headers="headers"
                            :items="items"
                            :loading="loading"

                            :options.sync="options"
                            :server-items-length="total"
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-btn depressed small tile color="success" :to="{name: 'vijesti-create'}">Dodaj novu vijest</v-btn>
                                <v-spacer></v-spacer>
                                <v-text-field
                                        v-model="search"
                                        append-icon="mdi-magnify"
                                        dense
                                        outlined
                                        label="Search"
                                        single-line
                                        hide-details
                                ></v-text-field>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.created_at="{ item }">
                            <span>{{ item.created_at | date}}</span>
                        </template>
                        <template v-slot:item.option="{ item }">
                            <v-btn icon :to="{name: 'vijesti-create', params: {item: item}}">
                                <v-icon small>{{'mdi-pencil'}}</v-icon>
                            </v-btn>
                            <v-btn icon @click="remove(item)">
                                <v-icon small>{{'mdi-delete'}}</v-icon>
                            </v-btn>
                            <v-btn icon :to="{name: 'fotografije-create', params: {news: item}}">
                              <v-icon small>mdi-image-album</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-col>
        <confirm-dialog ref="confirmBox"></confirm-dialog>
    </v-row>
</template>

<script>
	import bitPage from "../../components/layout/page";
    import confirmDialog from '../../components/global/confirm'
    import moment from "moment";

	export default {
		components: {
			bitPage,
            confirmDialog
		},
		head() {
			return {
				title: 'BitLab CMS'
			}
		},
		data: () => ({
			search: '',
			breadcrumbs: [
				{
					text: 'Vijesti',
					disabled: true
				},
			],
			headers: [
				{text: 'ID', value: 'id'},
				{text: 'Name', value: 'name', sortable: false},
				{text: 'Status', value: 'status', sortable: false},
				{text: 'Publish date', value: 'publish_date', sortable: false},
				{text: 'Created At', value: 'created_at', sortable: false},
				{text: 'Option', value: 'option', sortable: false}
			],
			items: [],
      loading: false,

      total: 0,
      options: {}
		}),
        methods: {
            getDoc() {
                this.loading = true;
                this.items = [];
                let params = new URLSearchParams(this.options).toString()
                params += '&sortBy=created_at&sortDesc=false'
                if(this.search) params += '&q=' + this.search
                this.axios.get(`/news/paginate?${params}`)
                    .then(res => {
                        res.data.data.forEach(item => {
                            let lang = item.langs.find(lang => lang.lang.lang_code === this.setLang);
                            item['name'] = lang && lang.title ? lang.title : '';
                            if (item['name'] !== '') this.items.push(item)
                        })

                        this.total = res.data.total
                    }).finally(() => this.loading = false)
            },
            remove(item) {
                this.$refs.confirmBox.open('Remove article', 'Are you sure want to delete this article?')
                    .then(() => this.axios.delete(`/news/${item.id}`).then(() => {
                        this.items.splice(this.items.indexOf(item), 1)
                    }))
            }
        },
        computed: {
            setLang() {
                return this.$store.state.lang.code === 'en'
                    ? 'en' : this.$store.state.lang.code === 'la'
                        ? 'sr' : 'ћи'
            }
        },
        watch: {
            setLang() {
                this.getDoc();
            },
            options: {
              handler () {
                this.getDoc()
              },
              deep: true,
            },
            search() {
              this.getDoc()
            }
        },
        filters: {
            date(date) {
                return moment(date) && moment(date).format('DD MMM YYYY HH:mm')
            }
        },
	}
</script>
